import { MISCELLANEOUS_RESOURCES, PAGE_NAMES, ACTION } from 'constant';
import { REQUEST_STATUS } from '../constants';

export const makeActionList = (params: any) => {
	const { hasPermissionV2, filters } = params;

	return {
		bulkActions: [
			{
				name: 'Approve',
				id: 'approve',
				isEnabled: () => {
					return (
						filters?.requestStatus !== REQUEST_STATUS.REJECTED &&
						hasPermissionV2({
							configPageName: PAGE_NAMES.miscellaneous,
							configResourceName: MISCELLANEOUS_RESOURCES.refundRequest,
							configActionName: ACTION.approveAndRefundTournamentInBulk
						})
					);
				}
			},
			{
				name: 'Reject',
				id: 'reject',
				isEnabled: () => {
					return (
						filters?.requestStatus === REQUEST_STATUS.PENDING &&
						hasPermissionV2({
							configPageName: PAGE_NAMES.miscellaneous,
							configResourceName: MISCELLANEOUS_RESOURCES.refundRequest,
							configActionName: ACTION.approveAndRefundTournamentInBulk
						})
					);
				}
			}
		],
		rowActions: []
	};
};

export default {
	makeActionList
};
